import { access } from "fs";
import { AuthService } from "src/app/services";
import { Security } from "../Security";

export class UserDetail
{
     userId:number;
     userName:string;
     bartRoleId:number;
     bartRoleCode:string;
     bartRoleDescription:string;
     firstLastName:string;
     emailAddress:string;
     assignedFacilityNumbers:string;
     userHostAddress?:string;
     remotePort?:string;
     serverIP?:string;
     remoteHost?:string;
     printerShareName?:string="FALCON";
}

export class AccessUserInfo
{
    public static getUserInfo()
    {
        try
        {
            let enCryptedUserInfo=JSON.parse(localStorage.getItem("userInfo"));
            var value = Security.decrypt(enCryptedUserInfo);
            let obj:UserDetail= new UserDetail();
            obj=JSON.parse(value);
            return obj;
        }
        catch(error)
        {
            location.href="/error"
            throw new Error('Invalid user.');
            
        }
    }
    public static setSelectedFacilityMasterId(facilityMasterId:string)
    {
        sessionStorage.setItem("FacilityMasterId",facilityMasterId)
    }
    public static getSelectedFacilityMasterId():number
    {
        if(sessionStorage.getItem("FacilityMasterId") && Number(sessionStorage.getItem("FacilityMasterId"))>0)
        {
            return  Number(sessionStorage.getItem("FacilityMasterId"))
        }
        else{
            return null;
        }
    }
 
}
